/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Video = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m22 8-6 4 6 4V8Z" }],
    ["rect", { width: "14", height: "12", x: "2", y: "6", rx: "2", ry: "2" }]
  ]
];

export { Video as default };
//# sourceMappingURL=video.js.map
